module.exports = __webpack_public_path__ + "static/media/Jam8.be08eccf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/Jam8.svg
// module id = 609
// module chunks = 0